import $ from 'jquery';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import Web3EthPersonal from 'web3-eth-personal';
import _t from './translate';
import getNfsgxContract from './getNfsgxContract';

const claimNfsgxTokenRequest = async (address, value, transactionId) => {
  // let price = window.prompt('What is your bid?');
  const amount = (value * 1000000).toFixed(0);

  if (typeof Web3EthPersonal === 'undefined') {
    require('web3-eth-personal');
  }
  const personal = new Web3EthPersonal(ethereum);
  const accounts = await web3Client.eth.getAccounts();

  await $.post('/api/wallet/nonce', `address=${accounts[0]}`).then(async (data) => {
    try {
      await personal.sign(web3Client.utils.toHex(`Amount: ${value} $NFSGX Address: ${accounts[0]} Nonce: ${data.nonce}`), accounts[0]).then(async (signature, err) => {
        await $.post('/api/wallet/claim', `signature=${signature}&amount=${value}&address=${address}&transaction_id=${transactionId}&nonce=${data.nonce}&wallet_type=NFSGX`, async (data) => {
          if (data.signature) {
            const nfsgxContract = getNfsgxContract();

            try {
              // eslint-disable-next-line max-len
              const response = await nfsgxContract.methods.transferFromLayer2(amount, data.transactionId, data.signature).send(0, {
                from: address,
                maxPriorityFeePerGas: null,
                maxFeePerGas: null,
              });
              if (response.status) {
                Swal.fire(
                  _t('Success!'),
                  'Successfully transferred your tokens to Avalanche',
                  'success',
                );
                document.location.reload(true);
              }
            } catch (ex) {
              console.log(ex);
              Swal.fire(
                _t('Error!'),
                _t(ex.message),
                'error',
              );
            }
          } else if (data.message) {
            Swal.fire(
              _t('Error!'),
              _t(data.message),
              'error',
            );
          } else {
            Swal.fire(
              _t('Error!'),
              _t('Operation Failed'),
              'error',
            );
          }
        }, 'json');
      });
    } catch (e) {
      Swal.fire(
        _t('Failed!'),
        _t(e.message),
        'error',
      );
    }
  });
};

export default claimNfsgxTokenRequest;
